/* eslint-disable max-len */
import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const ArrowEIPIcon = ({ className }) => (
  <SvgIcon viewBox='0 0 19.648 11.37' className={className}>
    <g id="Component_133_1" data-name="Component 133 – 1" transform="translate(0.75 1.061)">
      <path id="Path_13882" data-name="Path 13882" strokeLinejoin="round" d="M2360.908,1120.023l4.625,4.624,4.624-4.624" transform="translate(-1106.5 2370.157) rotate(-90)"/>
      <line id="Line_1580" data-name="Line 1580" fill="none" stroke="#0085ff" strokeLinecap="round" strokeWidth="1.5px" x2="18" transform="translate(0 4.624)"/>
    </g>
  </SvgIcon>
);

export default ArrowEIPIcon;
